import { Observable } from 'rxjs';
import { IUserDto } from './../../../models/user.dto';

export abstract class UsersContract {
  abstract get(userID: string): Observable<IUserDto>;
}
